/* eslint-disable no-fallthrough */
import * as actionTypes from './actiontypes';
import states from './states';
import { MESSAGE_NLP_SNAPSHOT_UPDATED } from '../nlp_details/actiontypes';
import { GLOBAL_UPDATE_MESSAGE, GLOBAL_UPDATE_PROFILE_DATA_IN_CONVERSATIONS } from '../page_details/actiontypes';
import { MODULE_DATA } from '../../config/constants';

const history_details = (state = states.history_details, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_SELECTED_DATE_RANGE:
      return {
        ...state,
        selected_date_range: action.payload ? [...action.payload] : [...state.selected_date_range]
      };

    case actionTypes.HISTORY_LOADING:
      return {
        ...state,
        loaders: {
          ...state.loaders,
          history_loading: true,
          history_loaded: false,
        }
      };

    case actionTypes.HISTORY_RECEIVED: {
      let current_chat_history_details = { ...state.current_chat_history_details };
      if (current_chat_history_details.active_chat_item && action.payload.chatSessions) {
        let index = action.payload.chatSessions.findIndex(item => item.sessionId === current_chat_history_details.active_chat_item.sessionId);
        if (index === -1) {
          current_chat_history_details = {
            ...state.current_chat_history_details,
            active_chat_item: null,
            messages: [],
            user_profile_details: {}
          }
        }
      }
      return {
        ...state,
        chat_history_list: action.payload && action.payload.chatSessions ? [...action.payload.chatSessions] : [],
        load_more_history: action.payload && action.payload.chatSessions && action.payload.chatSessions.length === MODULE_DATA.HISTORY.LOAD_MORE_HISTORY_COUNT,
        current_chat_history_details,
        total_history_count: action.payload && action.payload.totalCount ? action.payload.totalCount : 0,
        loaders: {
          ...state.loaders,
          history_loading: false,
          history_loaded: true,
        }
      };
    }

    case actionTypes.HISTORY_ERROR:
      return {
        ...state,
        loaders: {
          ...state.loaders,
          history_loading: false,
          history_loaded: false,
        }
      };

    case actionTypes.MORE_HISTORY_RECEIVED:
      return {
        ...state,
        chat_history_list: action.payload && action.payload.chatSessions ? [...state.chat_history_list, ...action.payload.chatSessions] : [...state.chat_history_list],
        load_more_history: action.payload && action.payload.chatSessions && action.payload.chatSessions.length === MODULE_DATA.HISTORY.LOAD_MORE_HISTORY_COUNT,
      };

    case actionTypes.UPDATE_HISTORY_FILTER: {
      return {
        ...state,
        selected_filters: {
          ...state.selected_filters,
          [action.payload.filterKey]: action.payload.value
        }
      };
    }

    case actionTypes.REMOVE_HISTORY_FILTER_ITEM: {
      let selected_filters = { ...state.selected_filters };
      let array = selected_filters[action.payload.filterKey].filter((item) => { return item.id !== action.payload.id });

      return {
        ...state,
        selected_filters: {
          ...state.selected_filters,
          [action.payload.filterKey]: array
        }
      };
    }

    case actionTypes.CLEAR_HISTORY_FILTER: {
      return {
        ...state,
        selected_filters: {}
      };
    }

    case actionTypes.CLEAR_CURRENT_HISTORY_CHAT_ITEM: {
      return {
        ...state,
        current_chat_history_details: {
          ...state.current_chat_history_details,
          active_chat_item: null,
          messages: [],
          user_profile_details: {}
        },
      };
    }

    case actionTypes.SET_CURRENT_HISTORY_CHAT_ITEM: {
      return {
        ...state,
        current_chat_history_details: {
          ...state.current_chat_history_details,
          active_chat_item: action.payload
        }
      };
    }

    case actionTypes.GET_CURRENT_HISTORY_LOADING: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          current_chat_history_loading: true,
          current_chat_history_load_error: false,
        }
      };
    }

    case actionTypes.GET_CURRENT_HISTORY_RECEIVED: {
      let current_chat_history_details = { ...state.current_chat_history_details };
      if (action.payload && action.payload.sessionId && action.payload.sessionId.trim().length > 0) {
        current_chat_history_details = {
          ...state.current_chat_history_details,
          messages: action.payload.chatLogs ? [...action.payload.chatLogs] : [],
          user_profile_details: action.payload.userProfileDetails ? action.payload.userProfileDetails : {}
        };
      }
      return {
        ...state,
        current_chat_history_details,
        loaders: {
          ...state.loaders,
          current_chat_history_loading: false,
          current_chat_history_load_error: false,
        }
      };
    }

    case actionTypes.GET_CURRENT_HISTORY_FAILED: {
      return {
        ...state,
        current_chat_history_details: {
          ...state.current_chat_history_details,
          active_chat_item: null,
          messages: [],
          user_profile_details: {}
        },
        loaders: {
          ...state.loaders,
          current_chat_history_loading: false,
          current_chat_history_load_error: true,
        }
      };
    }

    case MESSAGE_NLP_SNAPSHOT_UPDATED: {
      //TODO: same reducer used in conversation and chathistory. check if any conflict which can arises.
      let messages = [...state.current_chat_history_details.messages];

      if (action.payload && action.payload.chatlogId) {
        const index = messages.findIndex((message) => { return (message.chatlogId && message.chatlogId === action.payload.chatlogId) });
        if (index !== -1) {
          let updated_message = {
            ...messages[index],
          };
          if (messages[index].prevNLPSnapshot) {
            updated_message = {
              ...messages[index],
              NLPSnapshot: action.payload.NLPSnapshot
            };
          } else {
            updated_message = {
              ...messages[index],
              prevNLPSnapshot: messages[index].NLPSnapshot,
              NLPSnapshot: action.payload.NLPSnapshot
            };
          }

          messages = [...state.current_chat_history_details.messages.slice(0, index), updated_message, ...state.current_chat_history_details.messages.slice(index + 1)];
        }
      }

      return {
        ...state,
        current_chat_history_details: {
          ...state.current_chat_history_details,
          messages,
        }
      };
    }

    case actionTypes.UPDATE_CUSTOM_AGENT_NOTE_FORM_IN_HISTORY: {
      if (state.current_chat_history_details.active_chat_item) {
        return {
          ...state,
          current_chat_history_details: {
            ...state.current_chat_history_details,
            user_profile_details: {
              ...state.current_chat_history_details.user_profile_details,
              customAgentNotes: {
                ...state.current_chat_history_details.user_profile_details.customAgentNotes,
                form: action.payload
              }
            }
          }
        }
      }
      break;
    }

    case actionTypes.UPDATE_REVIEW_STATUS_IN_HISTORY: {
      let index = -1;
      index = state.chat_history_list.findIndex(chat_item => chat_item.sessionId === action.payload.sessionId);
      return {
        ...state,
        chat_history_list: index === -1 ? [...state.chat_history_list] :
          [
            ...state.chat_history_list.slice(0, index),
            { ...state.chat_history_list[index], reviewStatus: action.payload.reviewStatus },
            ...state.chat_history_list.slice(index + 1)
          ],
        current_chat_history_details: {
          ...state.current_chat_history_details,
          active_chat_item: state.current_chat_history_details.active_chat_item && state.current_chat_history_details.active_chat_item.sessionId === action.payload.sessionId ?
            {
              ...state.current_chat_history_details.active_chat_item,
              reviewStatus: action.payload.reviewStatus
            } : null,
        }
      }
    }

    case GLOBAL_UPDATE_MESSAGE: {
      if (action.payload.psid && action.payload.chatlogId && action.payload.changedValue && state.current_chat_history_details.active_chat_item && state.current_chat_history_details.active_chat_item.psid === action.payload.psid) {
        let messages = [...state.current_chat_history_details.messages];
        const index = messages.findIndex(message => (message.chatlogId && message.chatlogId === action.payload.chatlogId));
        if (index !== -1) {
          messages = [
            ...state.current_chat_history_details.messages.slice(0, index),
            {
              ...messages[index],
              ...action.payload.changedValue
            },
            ...state.current_chat_history_details.messages.slice(index + 1)
          ];
        }
        return {
          ...state,
          current_chat_history_details: {
            ...state.current_chat_history_details,
            messages,
          }
        };
      }
    }

    case GLOBAL_UPDATE_PROFILE_DATA_IN_CONVERSATIONS: {
      if (state.current_chat_history_details.active_chat_item && state.current_chat_history_details.user_profile_details && state.current_chat_history_details.user_profile_details.sessionId === action.payload.sessionId) {
        return {
          ...state,
          current_chat_history_details: {
            ...state.current_chat_history_details,
            user_profile_details: {
              ...state.current_chat_history_details.user_profile_details,
              ...action.payload.changed_value
            }
          }
        }
      }
      else return state;
    }

    default:
      return state;
  }
}

export default history_details;



// WEBPACK FOOTER //
// ./src/data/redux/history_details/reducers.js